import api from '../../utils/api';
import history from '../../utils/history';
import { alertError, alertSuccess } from './alert';

let cancelPassword;

const resetEmail = (email) => {
  if (cancelPassword) {
    cancelPassword('Cancel send password');
  }

  const forgotPasswordUrl = `/users/sendForgotPasswordEmail?email=${email}`;
  return api.get(forgotPasswordUrl, {
    cancelToken: new api.CancelToken((c) => (cancelPassword = c)),
  });
};

export const sendEmailPassword = (email) => async (dispatch) => {
  try {
    const response = await resetEmail(email);
    if (response.data.success) {
      dispatch(alertSuccess([`Reset email was sent to `, <strong>{email}</strong>]));
      history.push('/signin');
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
